export default {
    WINDOW_SIZE_CHANGE: (state, action) => {
        // removed exact size for performance concerns
        // state = state.set("width", action.payload.width);
        // state = state.set("height", action.payload.height);
        return state.set("size", action.payload.size);
    }
};
